import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CanfarServiceType } from '../utils/types';
import type { RootState, AppDispatch } from './store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();

// the selected CANFAR service, looked up live from the catalog.
export function useSelectedCanfar(): CanfarServiceType | undefined {
  const selectedCanfarId = useAppSelector((state) => state.global.selectedCanfarId);
  const canfarServices = useAppSelector((state) => state.data.canfarServices ?? []);

  return useMemo(
    () =>
      selectedCanfarId !== undefined && selectedCanfarId !== ''
        ? canfarServices.find((service) => service.id === selectedCanfarId)
        : undefined,
    [canfarServices, selectedCanfarId],
  );
}
